"use client";

import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { axiosRequest } from "../../utility/axios";
import { apiBaseUrl } from "../../constant/endpoint";
import { useSelector } from "react-redux";
import ChipExchangeForm from "./chipExchangeForm.js";
import { maskPhone } from "../../helper";

export default function ChipExchange() {
  const [records, setRecords]     = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const rowsPerPage = 3;

  const loginSlice = useSelector((state) => state.loginSlice);
  const token = loginSlice.token;

  const fetchExchanges = async () => {
    try {
      const url = `${apiBaseUrl}/chip-exchange?page=1&size=${rowsPerPage}`;
      const res = await axiosRequest("GET", url, token);
      setRecords(res?.data?.exchangeList || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { fetchExchanges(); }, []);

  const chipSummary = (chips = []) =>
    chips.map((c) => `${c.quantity}×${c.denomination}`).join(", ") || "—";

  return (
    <Box sx={{ width: "100%", marginTop: { xs: "55px", md: "95px" } }}>
      <Box p={3} sx={{ padding: { xs: "16px", md: "32px" } }}>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h4" fontWeight="bold">Chip Exchange</Typography>
            <Typography color="text.secondary">
              Swap chip denominations without changing wallet balances
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<SwapHorizIcon />}
            onClick={() => setOpenDrawer(true)}
            sx={{ borderRadius: 3, height: 45 }}
          >
            New Exchange
          </Button>
        </Box>

        <Paper sx={{ borderRadius: 4, overflow: "hidden" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Player</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Chips Given</TableCell>
                <TableCell>Chips Received</TableCell>
                <TableCell align="right">Amount ()</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {records.length > 0 ? (
                records.map((rec) => (
                  <TableRow key={rec._id}>
                    <TableCell>{new Date(rec.date).toLocaleString()}</TableCell>
                    <TableCell>
                      <Typography fontWeight={600}>{rec.user_name || "—"}</Typography>
                      <Typography variant="caption" color="text.secondary">{rec.player_id}</Typography>
                    </TableCell>
                    <TableCell>{maskPhone(rec.phone) || "—"}</TableCell>
                    <TableCell>
                      <Typography variant="body2" color="error.main" fontWeight={600}>
                        {chipSummary(rec.chips_given)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="success.main" fontWeight={600}>
                        {chipSummary(rec.chips_received)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={700}>
                        {rec.total_given?.toLocaleString()}
                      </Typography>
                    </TableCell>
                    <TableCell>{rec.remarks || "—"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">No Exchange Records Found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>

        <ChipExchangeForm
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          refresh={fetchExchanges}
        />
      </Box>
    </Box>
  );
}
